<template>
	<!--  ViewClassroomBoardList.vue: 강의실 > 게시판 > 게시물목록 화면 (notice.html) -->
	<fragment>
		<class-header
			subname="온라인 기획과정>국방부교육"
			name="2019 국방부6기 온라인 기획"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
		></class-header>
		<section class="container">
			<nav class="side-nav">
				<a class="btn full-width round m-b-10" href="#none">새로운 설문 추가</a>
				<ul class="side-nav-menu bar clearfix">
					<li>
						<a href="#">찾아가는 국어문화학교(수강생용)</a>
					</li>
				</ul>
			</nav>
			<!-- //end .side-nav -->

			<div class="container-fiuld class-making-box clearfix">
				<div class="title-box b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">찾아가는 국어문화학교 설문 (수강생용)</div>
					<!-- <a class="modify m-t-5 text-center" href="#none">수정</a> -->
					<div class="btn-group pull-right p-10 p-r-0">
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
				</div>
				<div class="white-box clearfix">
					<p class="f-14 m-b-5">설문대상</p>
					<div class="input-group full-width">
						<span class="input-group-addon w180 p-r-5">
							<input class="form-control round m-b-0" type="text" value="제한없음" disabled>
						</span>
						<span class="input-group-addon">
							<input class="form-control text-left round m-b-0" type="text" value="강의 수강생" disabled>
						</span>
					</div>
					<p class="text-right">진행중 40 / 80</p>
				</div>

				<div class="white-box clearfix">
					<div class="input-group full-width m-b-15 p-b-10 b-b">
						<span class="input-group-addon w20 v-mid f-16 text-left">1.</span>
						<span class="input-group-addon w100 v-mid p-r-5">
							｜ 객관식 ｜
						</span>
						<span class="input-group-addon v-mid text-left p-r-5">
							연령대가?
						</span>
					</div>
					<!-- <hr class="m-t-15 m-b-15"> -->
					<div class="col-md-7">
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="radio" checked>
								<label for="table-check3">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								10대
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="radio">
								<label for="table-check3">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								20대
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="radio">
								<label for="table-check3">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								30대
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="radio">
								<label for="table-check3">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								40대 이상
							</span>
						</div>
					</div>
					<div class="col-md-5 b-l">
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
					</div>
				</div>

				<div class="white-box clearfix">
					<div class="input-group full-width m-b-15 p-b-10 b-b">
						<span class="input-group-addon w20 v-mid f-16 text-left">2.</span>
						<span class="input-group-addon w100 v-mid p-r-5">
							｜ 객관식 ｜
						</span>
						<span class="input-group-addon v-mid text-left p-r-5">
							관심있는 분야는?
						</span>
					</div>

					<div class="col-md-7">
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="checkbox" checked>
								<label for="table-check3" class="sq">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								언어생활
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="checkbox">
								<label for="table-check3" class="sq">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								언어생활
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="checkbox">
								<label for="table-check3" class="sq">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								언어생활
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="checkbox">
								<label for="table-check3" class="sq">체크버튼</label>
							</span>
							<span class="input-group-addon text-left w60 v-mid p-r-5">
								기타
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								<button @click="modalResult" class="btn-sm round">답변보기</button>
							</span>
						</div>
					</div>

					<div class="col-md-5 b-l">
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
					</div>
				</div>

				<div class="white-box clearfix">
					<div class="input-group full-width m-b-15 p-b-10 b-b">
						<span class="input-group-addon w20 v-mid f-16 text-left">3.</span>
						<span class="input-group-addon w100 v-mid p-r-5">
							｜ 서술형 ｜
						</span>
						<span class="input-group-addon v-mid text-left p-r-5">
							오늘의 기분을 서술하시오?
						</span>
					</div>
					<button  @click="modalResult" class="btn-sm round center-block">답변보기</button>
				</div>
				<div class="b-t p-15 p-l-0 p-r-0 m-t-30 m-b-30 clearfix">
					<button class="btn btn-blue round w160 pull-left">등록하기</button>
					<button class="btn round w160 pull-right">새로 입력하기</button>
				</div>
			</div>
			<!-- //end .container-fuild -->
		</section>
		<modal-class-survey-result :config="modals.classSurveyResult"></modal-class-survey-result>
		<common-footer></common-footer>
	</fragment>
</template>

<script>
import ModalClassSurveyResult from '../modals/ModalClassSurveyResult.vue'
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
//import CommonSideMenu from '../components/CommonSideMenu.vue'

//import axios from 'axios'
//import server from '../statics/server.js'

export default {
	// 컴포넌트 명
	name: 'ViewSurveyResult',
	mixins: [fnAdjustHeight],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		//ModalOnlineClass,
		ModalClassSurveyResult,
		//CommonSideMenu,
	},
	watch : {
	},
	mounted: function() {

	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			menus : [
				{name:'강의 목차',link:"/classroom/curriculum",selected:false},
				{name:'수강현황',link:"/classroom/apply/list",selected:false},
				{name:'수료관리',link:"/classroom/finish/test",selected:false},
				{name:'게시판',link:"/classroom/board/register",selected:true},
				{name:'설문',link:"",selected:false},
				{name:'강의정보',link:"",selected:false},
			],
			side_menu_selected : '',
			side_menus: [ // 사이드 메뉴
				{id: '1', name:'국어문화학교 소식',link:"",selected:false},
				{id: '2', name:'묻고답하기',link:"",selected:false},
				{id: '3', name:'자주하는질문',link:"",selected:false},
				{id: '4', name:'자료마당',link:"",selected:false},
			],
			side_buttons : [
				{name:'강의 가져오기', fn:this.onGetCurriculum},
				{name:'신규강의 만들기', fn:this.onCreateCurriculum}
			],
			buttons : [
				{name:'설문 만들기', fn:this.createSurvey},
			],
			create_board : false,
			list_board : false,
			mode : 2,
			modals: {
				classSurveyResult : ModalClassSurveyResult.default()
			}
		}
	},



	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		modalResult : function(){
			this.modals.classSurveyResult.show = true;
			// eslint-disable-next-line
			console.log('modalResult')

		},

	}
}
</script>
<style scope>

</style>
